import type { RootState } from '../store'
import type { ProcessRes } from '../types/mediaProcessing'

export const processDataSelector = (
  state: RootState,
  id: string
): ProcessRes | undefined => state.mediaProcessing.data[id]

export const processSelector = (state: RootState) => state.mediaProcessing.data
